import script from "./CustomLinksPart.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomLinksPart.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__